// extracted by mini-css-extract-plugin
export default {"page":"MN","top_block":"NN","heading":"ON","inner_text":"PN","starter_text":"QN","starter_cta":"RN","summary_block":"SN","cartsummary_wrap":"TN","price":"UN","pricing_wrap":"VN","summary_block_mob":"WN","summary":"XN","pricing_heading":"YN","products_summary":"ZN","summary_line":"aO","summary_price":"bO","summary_title":"cO"};
    if(module.hot) {
      // 1713211522576
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  